// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';


const getBookmarkHomeDetails = (id, contextConfiguration) => axios.get(
	`/bookmark_folders/${id}`,
	{
		...commonConfiguration,
		...contextConfiguration,
	}
).catch(onRequestError);

export default getBookmarkHomeDetails;